<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{ $t("general.add") }}
        </el-button>
      </el-form-item>
    </el-form>
    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('empIns8de.officename')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns8de.address')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns8de.occupation')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns8de.numberofpeople')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.num1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns8de.occupation2')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type2 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns8de.numberofpeople2')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.num2 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns8de.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{ $t("general.edit") }}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{ $t("general.delete") }}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--add-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="86%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left: 50px">
        <el-input type="hidden" v-model="ruleForm.name" />

        <el-row>
          <el-col :span="8">
            <div>
              <el-form-item :label="$t('empIns8de.officename')" prop="name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.address')" prop="address">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.date')" prop="date">
                <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left: 10px; width: 185px" type="date" placeholder></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.nameApply')" prop="nameApply">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.nameApply" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
                <el-button class="el-icon-info" type="text" @click="open1">{{
                  $t("general.hint")
                  }}</el-button>
              </el-form-item>

              <el-form-item label="届け先">
                <el-checkbox v-model="ruleForm.toWelfare" size="mini">厚生労働大臣</el-checkbox>
                <el-checkbox v-model="ruleForm.toDirector" size="mini">労働局長</el-checkbox>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="16">
            <div>
              <el-form-item :label="$t('empIns8de.occupation')" prop="type1" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.type1" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
                <el-link type="primary" class="el-icon-info" :underline="false"
                  href="https://www.settweb.jp/settweb/contents/hwShokushuIchiran.html" target="_blank">職種分類一覧</el-link>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.numberofpeople')" prop="num1" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.num1" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>&nbsp; 人
              </el-form-item>
              <el-form-item :label="$t('empIns8de.occupation2')" prop="type2" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.type2" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
                <el-link type="primary" class="el-icon-info" :underline="false"
                  href="https://www.settweb.jp/settweb/contents/hwShokushuIchiran.html" target="_blank">職種分類一覧</el-link>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.numberofpeople2')" prop="num2" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.num2" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>&nbsp; 人
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{ $t("general.confirm") }}</el-button>
        <el-button style="width: 120px" @click="s1_cancel('ruleForm')" size="medium">{{ $t("general.cancel") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="86%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left: 50px">
        <el-input type="hidden" v-model="ruleForm.name" />

        <el-row>
          <el-col :span="8">
            <div>
              <el-form-item :label="$t('empIns8de.officename')" prop="name">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.address')" prop="address">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.address" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.date')" prop="date">
                <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left: 10px; width: 185px" type="date" placeholder></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.nameApply')" prop="nameApply">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.nameApply" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
                <el-button class="el-icon-info" type="text" @click="open1">{{
                  $t("general.hint")}}</el-button>
              </el-form-item>

              <el-form-item label="届け先">
                <el-checkbox v-model="ruleForm.toWelfare" size="mini">厚生労働大臣</el-checkbox>
                <el-checkbox v-model="ruleForm.toDirector" size="mini">労働局長</el-checkbox>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="16">
            <div>
              <el-form-item :label="$t('empIns8de.occupation')" prop="type1" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.type1" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
                <el-link type="primary" class="el-icon-info" :underline="false"
                  href="https://www.settweb.jp/settweb/contents/hwShokushuIchiran.html" target="_blank">職種分類一覧</el-link>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.numberofpeople')" prop="num1" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.num1" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>&nbsp; 人
              </el-form-item>
              <el-form-item :label="$t('empIns8de.occupation2')" prop="type2" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.type2" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>
                <el-link type="primary" class="el-icon-info" :underline="false"
                  href="https://www.settweb.jp/settweb/contents/hwShokushuIchiran.html" target="_blank">職種分類一覧</el-link>
              </el-form-item>

              <el-form-item :label="$t('empIns8de.numberofpeople2')" prop="num2" label-width="460px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.num2" size="mini"
                  style="margin-left: 10px; width: 185px"></el-input>&nbsp; 人
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{ $t("general.confirm") }}</el-button>
        <el-button style="width: 120px" @click="s1_cancel('ruleForm')" size="medium">{{ $t("general.cancel") }}
        </el-button>
      </span>
    </el-dialog>

    <br />

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        // things: [
        //   {
        //     thingsId: 1,
        //     name: "離職票－1",
        //   },
        //   {
        //     thingsId: 2,
        //     name: "離職票－2",
        //   },
        // ],
        // cause: [
        //   {
        //     causeId: 1,
        //     name: "滅失",
        //   },
        //   {
        //     causeId: 2,
        //     name: "損傷",
        //   },
        //   {
        //     causeId: 3,
        //     name: "その他",
        //   },
        // ],

        ruleForm: {
          id: "",
          name: "",
          address: "",
          type1: "",
          num1: "",
          type2: "",
          num2: "",
          date: "",
          nameApply: "",
          toWelfare: false,
          toDirector: false,
          targetOffice: "",
        },
        rules: {
          date: [{
            required: true,
            message: this.$t("general.please_select"),
            trigger: "blur",
          },],
          targetOffice: [{
            required: true,
            message: "届け先をクリックしてください。",
            trigger: "blur",
          },],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
      };
    },
    methods: {
      open1() {
        const h = this.$createElement;
        this.$notify({
          title: this.$t("empIns8de.open1Title"),
          message: h(
            "i", {
            style: "color: teal",
          },
            this.$t("empIns8de.open1Msg")
          ),
        });
      },
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');

        if (row.toWelfare == true) {
          window.open("/pdf/雇用保険適用除外申請書（厚生労働大臣への申請）" + row.date + "uid=" + uid + ".pdf");
        }
        if (row.toDirector == true) {
          window.open("/pdf/雇用保険適用除外申請書（労働局長への申請）" + row.date + "uid=" + uid + ".pdf");
        }
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
          method: "post",
          url: "/EmpIns8PDF",
          data: postData,
        })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 300);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleDelete(index, row) {
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
              method: "post",
              url: "/deleteEmpIns8",
              data: postData,
            })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageEmpIns8")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then((_) => {
            this.emptyUserData();
            done();
          })
          .catch((_) => { });
      },
      handleCurrentChange() {
        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
          method: "post",
          url: "/pageEmpIns8",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          name: "",
          address: "",
          type1: "",
          num1: "",
          type2: "",
          num2: "",
          date: "",
          toWelfare: false,
          toDirector: false,
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              name: this.ruleForm.name,
              address: this.ruleForm.address,
              type1: this.ruleForm.type1,
              num1: this.ruleForm.num1,
              type2: this.ruleForm.type2,
              num2: this.ruleForm.num2,
              date: this.ruleForm.date,
              nameApply: this.ruleForm.nameApply,
              toWelfare: this.ruleForm.toWelfare,
              toDirector: this.ruleForm.toDirector,
            });
            this.axios({
              method: "post",
              url: "/insertEmpIns8",
              data: postData,
            })
              .then((response) => {
                this.axios
                  .post("/pageEmpIns8")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed"),
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              name: this.ruleForm.name,
              address: this.ruleForm.address,
              type1: this.ruleForm.type1,
              num1: this.ruleForm.num1,
              type2: this.ruleForm.type2,
              num2: this.ruleForm.num2,
              date: this.ruleForm.date,
              nameApply: this.ruleForm.nameApply,
              toWelfare: this.ruleForm.toWelfare,
              toDirector: this.ruleForm.toDirector,
            });
            this.axios({
              method: "post",
              url: "/updateEmpIns8",
              data: postData,
            })
              .then((response) => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed"),
            });
            return false;
          }
        });
      },
      onSearch() {
        let postData = this.qs.stringify({
          name: this.search,
        });
        this.axios({
          method: "post",
          url: "/ListByNameEmpIns8",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
            this.disablePage = true;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      getPages() {
        this.axios
          .post("/rowsEmpIns8")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },
    created() {
      this.axios
        .post("/pageEmpIns8")
        .then((response) => {
          this.show = true;
          this.tableData = response.data;
        })
        .catch((error) => {
          // this.show = false;
          // this.$message({
          //   type: 'error',
          //   message: '開発中です。'
          // });
          // console.log(error);
        });

      this.axios
        .post("/rowsEmpIns8")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .item1 {
    visibility: hidden;
  }

  .item2 {
    visibility: hidden;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns8.vue